import { Fragment, ReactNode, useState } from 'react';
import { AppChat } from '../chat/AppChat';
import { useLocation } from '@tanstack/react-router';
import { ApplicationShell } from '@rhino-project/ui-heroui';
import { PrimaryNavbar } from '../primaryNavbar/components/PrimaryNavbar';
import { SecondaryNavigation } from '../app/SecondaryNavigation';
import { useFocusMode } from '../../hooks/useFocusMode';

export const AppShell = ({ children }: { children: ReactNode }) => {
  const [resultsVersion, setResultsVersion] = useState(0);
  const { focus } = useFocusMode();
  const { pathname } = useLocation();

  // Focus mode only applies on the Scout route, and only changes anything at
  // >=xl. When active, drop the persistent sidebar column so Scout goes
  // full-bleed; the shell keeps navigation reachable via the hamburger.
  const compact = focus && pathname.endsWith('/scout');

  return (
    <ApplicationShell compact={compact}>
      <ApplicationShell.Sidebar>
        <ApplicationShell.Nav>
          <PrimaryNavbar />
        </ApplicationShell.Nav>
        <ApplicationShell.Secondary>
          <SecondaryNavigation />
        </ApplicationShell.Secondary>
      </ApplicationShell.Sidebar>
      <ApplicationShell.Main>
        <Fragment key={resultsVersion}>{children}</Fragment>
      </ApplicationShell.Main>
      <AppChat
        onShowResults={() => setResultsVersion((version) => version + 1)}
      />
    </ApplicationShell>
  );
};
